export default process.env.REACT_APP_ENVIRONMENT === 'production';
